import i18n from "lib/i18n";
import MomentUtils from "@date-io/moment";
import PropTypes from "prop-types";
import React from "react";
import { DateTimePicker as UIDateTimePicker } from "@theconversation/ui";

const DateTimePicker = ({
  disabled,
  onChange,
  value,
}) => {
  const labelFunc = (date) => {
    if (disabled) {
      return i18n.t("comment_manager.labels.comments_closed");
    }

    if (date) {
      return date.format("LLL");
    }

    return i18n.t("comment_manager.labels.comments_opened");
  };

  return (
    <UIDateTimePicker
      allowKeyboardControl
      clearable
      dateManagementLibrary={MomentUtils}
      disabled={disabled}
      label={i18n.t("comment_manager.labels.schedule_off")}
      labelFunc={labelFunc}
      onChange={onChange}
      value={value}
    />
  );
};

DateTimePicker.defaultProps = {
  value: "",
};

DateTimePicker.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default DateTimePicker;
